module.exports = __webpack_public_path__ + "img/视频封面8.ecb44a4e.png";